module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0621.b922b9e6.jpg";